
                import "css-modules://src_components_inputfile"
                export default {"Main":"_a131ac","Label":"_f4c0e5","DummyInput":"_646049","Placeholder":"_fd37e6","ButtonContainer":"_b5ecf8","Button":"_593a83","Input":"_a3a599"}
            